import { useRef, useState, useMemo } from 'react';
import { useResizeObserver } from '@react-aria/utils';
import { borderRadius } from '@indeed/ifl-tokens';

const DROPZONE_STROKE = 1;
const HALF_STROKE = DROPZONE_STROKE / 2;
const LG_RADIUS = parseFloat(borderRadius.lg) * 16;
const DASH_LENGTH = 8;
const useFileUploadDashedPath = () => {
  const dropzoneRef = useRef(null);
  const [{
    width,
    height
  }, setDropzoneSize] = useState({
    width: 0,
    height: 0
  });
  useResizeObserver({
    ref: dropzoneRef,
    onResize: () => {
      requestAnimationFrame(() => {
        const rect = dropzoneRef.current?.getBoundingClientRect();
        if (rect && (rect.width !== width || rect.height !== height)) {
          setDropzoneSize({
            width: rect.width,
            height: rect.height
          });
        }
        const newPathLength = pathRef.current?.getTotalLength();
        if (newPathLength && pathLength !== newPathLength) {
          setPathLength(newPathLength);
        }
      });
    }
  });

  // Tracking path length so we can determine how to evenly distribute the space in between the dashes (which are a
  // fixed length).
  const [pathLength, setPathLength] = useState(0);
  const pathRef = useRef(null);
  const pathD = useMemo(() => `M ${LG_RADIUS + HALF_STROKE} ${HALF_STROKE}
        L ${width - LG_RADIUS - HALF_STROKE} ${HALF_STROKE}
        A ${LG_RADIUS} ${LG_RADIUS} 0 0 ${DROPZONE_STROKE} ${width - HALF_STROKE} ${LG_RADIUS + HALF_STROKE}
        L ${width - HALF_STROKE} ${height - LG_RADIUS - HALF_STROKE}
        A ${LG_RADIUS} ${LG_RADIUS} 0 0 ${DROPZONE_STROKE} ${width - LG_RADIUS - HALF_STROKE} ${height - HALF_STROKE}
        L ${LG_RADIUS + HALF_STROKE} ${height - HALF_STROKE}
        A ${LG_RADIUS} ${LG_RADIUS} 0 0 ${DROPZONE_STROKE} ${HALF_STROKE} ${height - LG_RADIUS - HALF_STROKE}
        L ${HALF_STROKE} ${LG_RADIUS + HALF_STROKE}
        A ${LG_RADIUS} ${LG_RADIUS} 0 0 ${DROPZONE_STROKE} ${LG_RADIUS + HALF_STROKE} ${HALF_STROKE}
        Z`, [height, width]);
  const dashedPathDropzoneProps = {
    ref: dropzoneRef
  };
  const dashedPathSvgProps = {
    height,
    width,
    pathLength
  };
  const dashedPathProps = {
    ref: pathRef,
    d: width === 0 || height === 0 ? undefined : pathD
  };
  return {
    dashedPathDropzoneProps,
    dashedPathSvgProps,
    dashedPathProps
  };
};

export { DASH_LENGTH, DROPZONE_STROKE, HALF_STROKE, LG_RADIUS, useFileUploadDashedPath };
